<div class="loading-container">
    <p>Redirecting to JNJ Application... Please wait.</p>
    <div class="spinner"></div> <!-- You can use CSS or a library for the spinner -->
</div>
  